import React from 'react';
import Icon from '../../../components/AppIcon';

const TableHeader = ({ sortConfig, onSort, allSelected, onSelectAll, isAdmin }) => {
  const baseColumns = [
    { key: 'select', label: '', sortable: false },
    { key: 'name', label: 'Patient', sortable: true },
    { key: 'contact', label: 'Contact', sortable: false },
    { key: 'registrationDate', label: 'Inscription', sortable: true },
    { key: 'activeCases', label: 'Conception actifs', sortable: true },
    { key: 'lastVisit', label: 'Dernière visite', sortable: true },
    { key: 'status', label: 'Statut', sortable: true },
    { key: 'actions', label: 'Actions', sortable: false }
  ];

  const columns = isAdmin
    ? [
        ...baseColumns.slice(0, 7),
        { key: 'dentist_client', label: 'Dentiste / Clinique', sortable: true },
        ...baseColumns.slice(7)
      ]
    : baseColumns;

  const getSortIcon = (key) => {
    if (!sortConfig || sortConfig?.key !== key) {
      return <Icon name="ChevronsUpDown" size={16} className="text-muted-foreground" />;
    }
    return sortConfig?.direction === 'asc' ? (
      <Icon name="ChevronUp" size={16} className="text-primary" />
    ) : (
      <Icon name="ChevronDown" size={16} className="text-primary" />
    );
  };

  return (
    <thead className="bg-muted/50 border-b border-border">
      <tr>
        {columns?.map((column) => (
          <th
            key={column?.key}
            className={`px-6 py-3 text-left text-xs font-semibold text-foreground uppercase tracking-wider ${
              column?.sortable ? 'cursor-pointer hover:bg-muted transition-colors duration-200' : ''
            }`}
            onClick={() => column?.sortable && onSort(column?.key)}
          >
            {column?.key === 'select' ? (
              <input
                type="checkbox"
                checked={allSelected}
                onChange={(e) => onSelectAll(e?.target?.checked)}
                className="w-4 h-4 rounded border-border text-primary focus:ring-2 focus:ring-primary focus:ring-offset-2"
              />
            ) : (
              <div className="flex items-center gap-2">
                <span>{column?.label}</span>
                {column?.sortable && getSortIcon(column?.key)}
              </div>
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;